export default {
  setActivity: (state, payload) => {
    state.activityList = payload;
  },
  setAttendanceList: (state, payload) => {
    state.attendanceList = payload;
  },
  setLoading: (state, payload) => {
    state.loading = payload;
  },
  setLoadingDialog: (state, payload) => {
    state.loadingDialog = payload;
  },
  setSearch: (state, payload) => {
    state.search = payload;
  },
  toogleZenMode: state => (state.zenMode = !state.zenMode),
  setRecordsList: (state, payload) => {
    state.recordsList = payload;
  },

  setError: (state, payload) => {
    state.error = payload;
  },
  clearError: state => (state.error = null)
};
